/* eslint-disable no-plusplus,no-restricted-syntax,no-shadow */
import dayjs from 'dayjs';
import { isNil, isEmpty } from 'ramda';
import { I18n } from 'src/translations/i18n';
import Utils from 'src/utils';
import toastrError from 'src/helpers/toastr/toastrError';
import communicate from 'src/api/communicate';
import { loadExcelExport } from './excelActions';


export const REQUEST = 'LOAD_CALENDAR_EVENTS_LOG_REQUEST';
export const SUCCESS = 'LOAD_CALENDAR_EVENTS_LOG_SUCCESS';
export const FAIL = 'LOAD_CALENDAR_EVENTS_LOG_FAIL';

const OPERATION_TYPES = {
  create: I18n.t('created'),
  update: I18n.t('updated'),
  delete: I18n.t('deleted')
};

const loadCalendarEventsLogsRequest = () => ({ type: REQUEST });

const loadCalendarEventsLogsSuccess = (calendarEventsLog) => ({ type: SUCCESS, calendarEventsLog });

const loadCalendarEventsLogsFail = (error) => ({ type: FAIL, error });


const reformatData = (dataArray) => {
  const dateFormat = 'DD-MMM-YYYY HH:mm'; // for users
  const dateFormatDB = 'YYYY-MM-DDTHH:mm:ss.SSS'; // from DB
  let operation = '';
  return dataArray.map((obj) => {
    const rObj = {};
    operation = OPERATION_TYPES[obj.Operation];
    // console.log(`op: ${operation}`);
    rObj.Operation = operation;
    rObj.Created = dayjs(obj.Created, dateFormatDB).format('DD-MM-YYYY HH:mm'); // month by numbers then it easy to sort
    rObj.CreatorName = obj.Creator.Name;
    rObj.CreatorExternalCode = obj.Creator.Id; // Should be ExternalCode
    rObj.CreatorId = obj.Creator.Id;
    rObj.User = obj.User;
    rObj.CalendarEventId = obj.CalendarEventId;
    rObj.JobName = obj.Job.Name;
    rObj.WorkTimeBefore = {
      Start: obj.WorkTime.Start.Before !== null ? dayjs(obj.WorkTime.Start.Before, dateFormatDB).format(dateFormat) : ' ',
      Stop: obj.WorkTime.Stop.Before !== null ? dayjs(obj.WorkTime.Stop.Before, dateFormatDB).format(dateFormat) : ' '
    };
    rObj.WorkTimeAfter = {
      Start: obj.WorkTime.Start.After !== null ? dayjs(obj.WorkTime.Start.After, dateFormatDB).format(dateFormat) : ' ',
      Stop: obj.WorkTime.Stop.After !== null ? dayjs(obj.WorkTime.Stop.After, dateFormatDB).format(dateFormat) : ' '
    };
    if (!isNil(obj.Department.Before) && !isEmpty(obj.Department.Before)) {
      rObj.DepartmentBefore = obj.Department.Before.Name;
    } else {
      rObj.DepartmentBefore = '-'; // Sometimes object missing !!!
    }
    if (!isNil(obj.Department.After) && !isEmpty(obj.Department.After)) {
      rObj.DepartmentAfter = obj.Department.After.Name;
    } else {
      rObj.DepartmentAfter = '-';
    }
    rObj.Department = obj.Department;
    rObj.Difference = obj.WorkTime.Difference;
    return rObj;
  });
};

export function loadCalendarEventsLogs(props = {}) {
  return (dispatch) => {
    dispatch(loadCalendarEventsLogsRequest());
    return communicate({
      url: 'CalendarEvents/EventsLog',
      method: 'get',
      getParams: Utils.objects.getQueryStringFromObject(props) // '?period=2017-11-14,2017-11-14&departmentIds=&userIds=&jobIds=&workShiftIds=&wccIds='
    }).then((response) => {
      dispatch(loadCalendarEventsLogsSuccess(reformatData(response.data.Data)));
    }).catch((error) => {
      dispatch(loadCalendarEventsLogsFail(error));
      toastrError(error);
    });
  };
}

export const loadExcel = (params) => (dispatch) => {
  const request = {
    url: 'CalendarEvents/EventsLogExcel',
    query: Utils.objects.getQueryStringFromObject(params)
  };
  return dispatch(loadExcelExport(request));
};
